import React, {Dispatch, SetStateAction} from "react";
import {KubernetesAlert, kubernetesEvents} from "../../pages/alerts/KubernetesAlert";
import {cn} from "../ui/lib/utils";
import {Tooltip, TooltipContent, TooltipTrigger} from "../ui/tooltip";
import {capitalizeFirstLetter} from "../../utility/stringUtils";
import {Alert} from "../../pages/alerts/model";

export function KubernetesEventSelector(props: {
    alert: Alert,
    setAlert: Dispatch<SetStateAction<Alert>>
}) {
    return <div className={"flex flex-col gap-4"}>
        <div className={"flex justify-start gap-2"}>
            <div
                className={"h-[36px] w-[36px] border border-primary bg-primarytransparent text-textlight flex flex-col justify-center text-center font-semibold rounded"}>
                2
            </div>
            <div className={"text-lg flex flex-col justify-center text-center text-textlight"}>
                Select Event
            </div>
        </div>
        <div className={"flex justify-start"}>
            <div className={"flex gap-2 items-center"}>
                {
                    kubernetesEvents.map((event, index) => {
                        return <div key={index}
                                    className={cn("h-[32px] flex justify-center items-center text-textmedium border gap-2 p-2 rounded bg-none border-buttonborder hover:text-textlight hover:border hover:border-secondary cursor-pointer px-4", (props.alert.alert as KubernetesAlert).monitorEvent === event ? "border bg-secondarytransparenter border-secondary" : "")}
                                    onClick={() => {
                                        let k8sAlert = (props.alert.alert as KubernetesAlert)
                                        k8sAlert.monitorEvent = event
                                        props.setAlert({...props.alert, alert: k8sAlert})
                                    }}>
                            <Tooltip delayDuration={10}>
                                <TooltipTrigger>
                                    {capitalizeFirstLetter(event.name)}
                                </TooltipTrigger>
                                <TooltipContent side={"right"}
                                                className={"ml-4 bg-backgroundlight border text-textlight rounded"}>
                                    {event.description}
                                </TooltipContent>
                            </Tooltip>
                        </div>
                    })
                }
            </div>
        </div>
    </div>;
}